import { Modal as AntModal, ModalFuncProps } from 'antd';
import { t } from 'ttag';

export interface ConfirmProps extends ModalFuncProps {
  title: string;
  content: React.ReactNode;
  onOk: () => void;
  onCancel?: () => void;
  okText?: string;
  cancelText?: string;
  confirmDisabled?: boolean;
}

const confirm = ({
  title,
  content,
  onOk,
  onCancel,
  cancelText,
  confirmDisabled,
  ...otherProps
}: ConfirmProps) =>
  AntModal.confirm({
    title,
    content,
    cancelText: cancelText ?? t`No, Cancel`,
    okButtonProps: {
      type: 'primary',
      danger: true,
      disabled: confirmDisabled,
    },
    onOk,
    onCancel,
    ...otherProps,
  });

const Modal = {
  confirm,
};

export default Modal;
